var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNoAppointments = function SvgIconNoAppointments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "currentColor",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h64v64H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#959595",
    fillRule: "nonzero",
    d: "M56 12H8a6.006 6.006 0 0 0-6 6v37a6.006 6.006 0 0 0 6 6h48a6.006 6.006 0 0 0 6-6V18a6.006 6.006 0 0 0-6-6m4 43a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V25h56zM49 5a2 2 0 1 0-4 0v5h4zM19 5a2 2 0 1 0-4 0v5h4z"
  }))));
};
export { SvgIconNoAppointments as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgMGg2NHY2NEgweiIvPgogICAgICAgIDxnIGZpbGw9IiM5NTk1OTUiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik01NiAxMkg4YTYuMDA2IDYuMDA2IDAgMCAwLTYgNnYzN2E2LjAwNiA2LjAwNiAwIDAgMCA2IDZoNDhhNi4wMDYgNi4wMDYgMCAwIDAgNi02VjE4YTYuMDA2IDYuMDA2IDAgMCAwLTYtNnptNCA0M2E0IDQgMCAwIDEtNCA0SDhhNCA0IDAgMCAxLTQtNFYyNWg1NnYzMHpNNDkgNWEyIDIgMCAxIDAtNCAwdjVoNFY1ek0xOSA1YTIgMiAwIDEgMC00IDB2NWg0VjV6Ii8+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";